<template>
	<main>
		<div class="wrapper-form">
			<CardForm :card-title="getString('guided_registration')" :card-body="bodyCard" :cta-text="getString('registration_submitted')" :cta-done="ctaDone" @cta-click="ctaDone = false" cta-exists>
				<div ref="step-hook">
					<StepForm :steps="steps" :current-step="currentStep" @changed-current-step="(index) => { currentStep = index }" />
				</div>
				<div class="section-step section-step-first" v-show="currentStep === 0">
					<div class="heading-form">
						<h3>{{ getString("user_data") }}</h3>
						<p>{{ getString("description_info") }}</p>
					</div>
					<div>
						<AppTextInput name="inp-name-of-user" type="text" ref="user-name" :label="getString('personal_references')" :placeholder="getString('user_name')" @pressed-enter="pressedEnterUserName" />
					</div>
					<div class="mt-20">
						<AppTextInput name="inp-email" type="email" ref="email" :value="getPrefillEmail()" :label="getString('insert_your_email')" :placeholder="getString('email')" @pressed-enter="pressedEnterEmail" />
					</div>
					<div class="mt-20">
						<div class="phone-label">{{ getString('tel_number') }}</div>
						<div class="phone-container mt-4">
							<AppPhonePrefix ref="phone-prefix" class="input-phone-prefix" />
							<AppTextInput class="phone-wrapper" name="inp-phone" type="tel" ref="tel" :placeholder="getString('tel')" @pressed-enter="pressedEnterUserPhone" />
						</div>
					</div>
					<div class="mt-20">
						<AppTextInput type="password" ref="password" :label="getString('enter_password')" :placeholder="getString('password')" @pressed-enter="submitFirstStep" />
					</div>
					<div class="mt-20">
						<AppButton ref="input-first-step" @click="submitFirstStep" :text="getString('next')" :disabled="!isCaptchaReady" :loading="loadingEmail"/>
					</div>
					<div class="links-list mt-30">
						<p>{{ getString('already_registered') }} <a :href="linkLogin">{{ getString('login_here') }}</a></p>
						<p><a :href="linkForgotPassword">{{ getString('forgot_password') }}</a></p>
					</div>
				</div>
				<div class="section-step section-step-second" v-show="currentStep === 1">
					<div class="heading-form">
						<h3>{{ getString("business_data") }}</h3>
						<p>{{ getString("description_info_business") }}</p>
					</div>
					<div>
						<AppTextInput name="inp-name" type="text" ref="business-name" :label="getString('enter_business_name')" :placeholder="getString('business_name')" @pressed-enter="pressedEnterBusinessName" />
					</div>
					<div class="mt-20">
						<AppGoogleMapsInput name="signup-account-address" no-map :manual-editable="false" :label="getString('enter_business_location')" ref="business-location-input" :placeholder="getString('business_location')" class="demo-input" @changed-address="pressedEnterBusinessLocation" />
					</div>
					<div class="mt-20">
						<p class="business-type-label">{{ getString('business_type') }}</p>
						<div class="row centered business-type-row">
							<AppBusinessTypeCard
								v-for="typeCard in businessTypeCards"
								@click="businessType = typeCard.value"
								:active="typeCard.value === businessType"
								:title="typeCard.title"
								:imageSrc="typeCard.imageSrc"
								:value="typeCard.value"
							/>
						</div>
					</div>
					<div class="mt-20">
						<AppButton @click="submitSecondStep" :text="getString('next')" :disabled="!isCaptchaReady" :loading="loadingEmail"/>
					</div>
					<div class="links-list mt-30">
						<p>{{ getString('already_registered') }} <a :href="linkLogin">{{ getString('login_here') }}</a></p>
						<p><a :href="linkForgotPassword">{{ getString('forgot_password') }}</a></p>
					</div>
				</div>
				<div class="section-step section-step-third" v-show="currentStep === 2">
					<div class="heading-form">
						<h3>{{ getString("final_step_title") }}</h3>
						<p>{{ getString("description_info_contract") }}</p>
					</div>
					<div class="mt-20">
						<TermsAndConditions @contract-signed="termAndCondition = true" @contract-unsigned="termAndCondition = false" />
					</div>
					<div class="mt-20">
						<AppButton @click="submitFinalStep" :text="getString('sign_up')" :disabled="!isCaptchaReady" :loading="loadingEmail || loadingSignup"/>
					</div>
				</div>
			</CardForm>
			<div class="banner-help-block">
				<div class="row row-banner">
					<div class="col-6 col-6-img">
						<img class="image-banner-contact" src="https://img.qromo.io/img/web-site/image-banner-help.png" alt="Immagine banner hai bisogno di aiuto">
						<img src="https://img.qromo.io/img/web-site/image-banner-help-sign.svg" alt="Immagine segni grafici banner">
					</div>
					<div class="col-6 col-6-content">
						<h3>{{ getString('caps_need_help') }}</h3>
						<p>{{ getString(isItaly ? 'view_consulting_page_call' : 'view_consulting_page') }}</p>
						<div class="button-graphic">
							<div class="mt-20 align-cta">
								<a @click.prevent="handleSpokiClick" href="#"><AppButton id="spoki_signup" class="whatsapp-button" icon-left="logo-whatsapp" :text="getString('contact_us')" :disabled="loadingSpoki"/></a>
								<AppButton v-if="isItaly" id="call_signup" outline href="tel:+390282941999" :text="getString('call_us')"/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</main>
	<AppPopup
		ref="popup-go-login"
		:buttons="buttonsPopup"
		:title="getString('user_already')"
		:bodyText="getString('user_already_info')" >
	</AppPopup>
	<AppNotification ref="invalid-tel" :title="getString('error')" :body-text="getString('invalid_phone')" :type="-2" />
	<AppNotification ref="password-too-short" :title="getString('error')" :body-text="getString('password_too_short')" :type="-2" />
	<AppNotification ref="empty-name" :title="getString('error')" :body-text="getString('empty_name')" :type="-2" />
	<AppNotification ref="invalid-email" :title="getString('error')" :body-text="getString('invalid_email')" :type="-2" />
	<AppNotification ref="risky-email" :title="getString('error')" :body-text="getString('mail_verification_error')" :type="-2" />
	<AppNotification ref="captcha-failed" :title="getString('error')" :body-text="getString('captcha_failed')" :type="-2" />
	<AppNotification ref="too-many-mails" :title="getString('error')" :body-text="getString('too_many_mails')" :type="-2" />
	<AppNotification ref="invalid-address" :title="getString('error')" :body-text="getString('invalid_address')" :type="-2" :duration="7000" />
	<AppNotification ref="invalid-business-type" :title="getString('error')" :body-text="getString('invalid_business_type')" :type="-2" />
	<AppNotification ref="email-fail" :title="getString('error')" :body-text="getString('email_fail')" :type="-2" />
	<AppNotification ref="error-generic" :title="getString('error')" :body-text="getString('error_generic')" :type="-2" />
	<AppNotification ref="already-in-users" :title="getString('error')" :body-text="getString('already_in_users_temp_warn')" :type="-2" />
	<AppNotification ref="accept-general-conditions" :title="getString('error')" :body-text="getString('accept_general_conditions')" :type="-2" />
	<AppNotification ref="confirm-mail-sent" :title="getString('success')" :body-text="getString('confirm_mail_sent')" :type="1" :duration="8000" />
	<BannerCookie
		bottom
		base-color="29edc0"
	/>
</template>

<script>
import {useLanguageStore, useScriptStore} from "@/shared/stores";
import langObject from "@/console-signup/assets/json/langs.json";
import langObjectAuto from "@/console-signup/assets/json/auto.json";
import API from "@/shared/helpers/API";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppGoogleMapsInput from "@/shared/components/AppGoogleMapsInput.vue";
import AppButton from "@/shared/components/AppButton.vue";
import CardForm from "@/console-reset/components/CardForm.vue";
import TermsAndConditions from "@/console-signup/components/TermsAndConditions.vue";
import StepForm from "@/console-signup/components/StepForm.vue";
import AppNotification from "@/shared/components/AppNotification.vue";
import AppPopup from "@/shared/components/AppPopup.vue";
import AppSelect from "@/shared/components/AppSelect.vue";
import {validateEmail, validatePhone} from "@/shared/helpers/strings";
import AppPhonePrefix from "@/shared/components/AppPhonePrefix.vue";
import AppBusinessTypeCard from "@/shared/components/AppBusinessTypeCard.vue";
import BannerCookie from "@/new-menu/components/modals/BannerCookie.vue";
import {customEvent, injectHotjar} from "@/shared/helpers/events";

export default {
	components: {
		BannerCookie,
		AppPhonePrefix,
		AppBusinessTypeCard,
		AppButton, AppTextInput, CardForm, AppNotification, StepForm, AppGoogleMapsInput, TermsAndConditions, AppPopup, AppSelect},
	setup() {
		const languageStore = useLanguageStore();
		const scriptStore = useScriptStore();
		const isItaly = typeof COUNTRY !== "undefined" && COUNTRY === "IT";
		return {languageStore, getString: languageStore.getString, scriptStore, isItaly};
	},
	name: "App",
	data() {
		return {
			isCaptchaReady: false,
			loadingEmail: false,
			userName: null,
			userEmail: null,
			userPhone: null,
			businessName: null,
			businessAddress: null,
			businessType: null,
			userPassword: null,
			ctaDone: false,
			loadingSignup: false,
			currentStep: 0,
			termAndCondition: false,
			loadingSpoki: false
		}
	},
	computed: {

		steps() {
			return [{
				title: this.getString('user'),
				description: this.getString('upload_data'),
				image: "https://img.qromo.io/img/Icon-User-form.svg"
			},{
				title: this.getString('business'),
				description: this.getString('upload_data'),
				image: "https://img.qromo.io/img/icon-marketplace-form.svg"
			},{
				title: this.getString('final_step'),
				description: this.getString('accept_contract'),
				image: "https://img.qromo.io/img/icon-final-step-form.svg"
			}];
		},
		businessTypeCards() {
			return [
				{title: this.getString('business_type_food'), value: "restaurant", imageSrc: "https://qromomilan.s3.eu-south-1.amazonaws.com/img/signup-card-food-beverage.jpeg"},
				{title: this.getString('business_type_events'), value: "events", imageSrc: "https://qromomilan.s3.eu-south-1.amazonaws.com/img/signup-card-events.jpeg"},
				{title: this.getString('business_type_retail'), value: "other", imageSrc: "https://qromomilan.s3.eu-south-1.amazonaws.com/img/signup-card-retail.jpeg"}
			];
		},
		linkForgotPassword() {
			return URL_HTML + "/console/reset-password/";
		},
		linkLogin() {
			return URL_HTML+'/console/login/';
		},
		buttonsPopup() {
			let email = this.$refs && this.$refs.email ? encodeURIComponent(this.$refs.email.currentValue) : null;
			return [
				{text: this.getString('cancel'), negative: true},
				{text: this.getString('login'), callback: () => {
						if(email) {
							window.location.replace(URL_HTML+"/console/login/?email="+email)
						} else {
							window.location.replace(URL_HTML+"/console/login/")
						}
					}}
			];
		},
		bodyCard() {
			let refPart = ref ? " (Referente "+ref+")" : "";
			return this.getString('follow_step')+refPart;
		}
	},
	methods: {
		getPrefillEmail() {
			if(prefillEmail) {
				return prefillEmail;
			} else {
				return "";
			}
		},
		pressedEnterUserName(value) {
			if(this.$refs && this.$refs['email'] && value.length > 3) {
				this.$refs['email'].focus()
			} else {
				this.$refs["empty-name"].openNotification();
			}
		},
		pressedEnterEmail(value) {
			if(this.$refs && this.$refs['tel'] && validateEmail(value)) {
				this.$refs['tel'].focus();
			} else {
				this.$refs["invalid-email"].openNotification();
			}
		},
		pressedEnterUserPhone(value) {
			if(this.$refs && this.$refs['password'] && validatePhone(value)) {
				this.$refs['password'].focus()
			} else {
				this.$refs["invalid-tel"].openNotification();
			}
		},
		submitFirstStep() {
			const userName = this.$refs && this.$refs['user-name'] ? this.$refs['user-name'].currentValue : null;
			if(userName && userName.length > 0) {
				const email = this.$refs.email ? this.$refs.email.currentValue : null;
				if(email && validateEmail(email)) {
					let telPrefixCountry = this.$refs['phone-prefix'] ? this.$refs['phone-prefix'].currentCountry : null;
					telPrefixCountry = telPrefixCountry ? telPrefixCountry.prefix_number : '+39';
					let tel = this.$refs.tel ? this.$refs.tel.currentValue : null;
					tel = tel ? tel.replace(/\s/g, '') : null;
					let fullTel = telPrefixCountry+(tel ? tel : "");
					if(tel && validatePhone(fullTel)) {
						const password = this.$refs['password'].currentValue;
						if(password.length > 7) {
							this.userName = userName;
							this.userEmail = email;
							this.userPhone = fullTel;
							this.userPassword = password;
							this.currentStep++;
							this.scrollToElement();
							requestAnimationFrame(() => {
								requestAnimationFrame(() => {
									if(this.$refs['business-name']) {
										this.$refs['business-name'].focus()
									}
								})
							})
							customEvent('presignup_step1', {
								user_name: this.userName,
							});
						} else {
							this.$refs["password-too-short"].openNotification();
						}
					} else {
						this.$refs["invalid-tel"].openNotification();
					}
				} else {
					this.$refs["invalid-email"].openNotification();
				}
			} else {
				this.$refs["empty-name"].openNotification();
			}

		},
		pressedEnterBusinessName() {
			const currentValueBusiness = this.$refs['business-name'].currentValue;
			if(this.$refs && this.$refs["business-location-input"] && this.$refs["business-location-input"].$refs["text-input"] && currentValueBusiness.length > 0) {
				this.$refs["business-location-input"].$refs["text-input"].focus();
			} else {
				this.$refs["empty-name"].openNotification();
			}
		},
		pressedEnterBusinessLocation(address) {
			if(address.lat && address.lng && address.data && address.address) {
				this.businessAddress = address;
			} else {
				this.$refs["invalid-address"].openNotification();
			}
		},
		submitSecondStep() {
			const businessName = this.$refs && this.$refs['business-name'] ? this.$refs['business-name'].currentValue : null;
			if(this.$refs && businessName && businessName.length > 0) {
				if(this.businessAddress) {
					if(this.businessType) {
						this.businessName = businessName;
						this.currentStep++;
						this.scrollToElement();

						customEvent('presignup_step2', {
							business_name: this.businessName,
							business_address: this.businessAddress?.address || '',
						});
					} else {
						this.$refs["invalid-business-type"].openNotification();
					}
				} else {
					this.$refs["invalid-address"].openNotification();
				}
			} else {
				this.$refs["empty-name"].openNotification();
			}
		},
		submitFinalStep() {
			if(this.loadingSignup) {
				return
			}
			if(this.termAndCondition === true) {
				this.loadingSignup = true;
				grecaptcha.execute('6Lc_oK8ZAAAAAHHQSZ2DkU3Ja-jCDML2hqpuIBuC', {action: 'signup'}).then((captchaToken) => {
					let os = "webapp";
					if(typeof iOSNative !== 'undefined') {
						os = "ios";
					}

					let tokenAPI = API.init().generateToken([this.userEmail, this.userPassword, captchaToken, os]);
					let params = {
						token: tokenAPI,
						email: this.userEmail,
						password: this.userPassword,
						captcha: captchaToken,
						os: os,
						username: this.userName,
						name:  this.businessName,
						phone: this.userPhone,
						address: this.businessAddress.address,
						lat: this.businessAddress.lat,
						lng: this.businessAddress.lng,
						type: this.businessType,
						address_data: JSON.stringify(this.businessAddress.data),
						no_ft: noFt,
						country: COUNTRY,
					};
					let refAd = localStorage.getItem('referral_ad');
					if(!params.ref && refAd) {
						params.ref = refAd;
					}
					if(codCliente) {
						params.import_id = codCliente;
					}
					this.loadingEmail = true;

					API.init().signup(params, (response) => {
						this.loadingEmail = false;
						this.loadingSignup = false;
						if(response && response.result === 'OK') {
							this.$refs["confirm-mail-sent"].openNotification();
							this.ctaDone = true;
							this.scrollToTop();
							setTimeout(() => {
								this.currentStep = 0;
							}, 500);

							if(typeof iOSNative !== 'undefined' && window.webkit) {
								window.webkit.messageHandlers.signupHandler.postMessage()
							}

						} else if(response && response.details) {
							if(response.details === "captcha") {
								this.$refs["captcha-failed"].openNotification();
							} else if(response.details === "already_registered") {
								this.$refs["popup-go-login"].toggleStatus(true);
							} else if(response.details === "too_many_emails") {
								this.$refs["too-many-mails"].openNotification();
							} else if(response.details === "failed_to_add_address") {
								this.$refs["invalid-address"].openNotification();
							} else if(["bouncer_undeliverable", "bouncer_risky", "bounced"].includes(response.details)) {
								this.$refs["risky-email"].openNotification();
							} else if(response.details === "email_fail") {
								this.$refs["email-fail"].openNotification();
							} else if(response.details === "already_invited_to_business") {
								this.$refs["already-in-users"].openNotification();
							} else {
								this.$refs["error-generic"].openNotification();
							}
						} else {
							this.$refs["error-generic"].openNotification();
						}
					});
				});
			} else {
				this.$refs["accept-general-conditions"].openNotification();
			}
		},
		scrollToElement() {
			window.scrollTo({
				top: 185,
				behavior: 'smooth'
			});
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		},
		buttonSendEmail() {
			window.location.href = "mailto:team@qromo.help";
		},
		handleSpokiClick(event) {
			if (this.loadingSpoki) return;

			this.loadingSpoki = true;
			const spokiUrl = "https://app.spoki.it/wd/7d6d55a1-ead0-4b2c-9e0c-99b7b14495f8/";
			let refAd = localStorage.getItem('referral_ad');

			API.init().sendCustomEvent('signup_spoki', refAd, (response) => {
				window.location.href = spokiUrl;
			});
		}
	},
	created() {
		this.languageStore.addStrings(langObject, "signup", langObjectAuto);
		API.init(URL_HTML, URL_HTML+"/console/login/");
		this.scriptStore.loadScript("captcha", () => {

			if(typeof grecaptcha !== "undefined") {
				grecaptcha.ready(() => {
					this.isCaptchaReady = true;
				});
			} else {
				console.warn("captcha undefined")
			}

		});

		document.addEventListener('dblclick', function(event) {
			event.preventDefault();
		}, { passive: false });

		if(!TEST && !localStorage.getItem('refresh_token')) {
			setTimeout(() => {
				injectHotjar();
			}, 320);
		}
	},
}
</script>

<style lang="scss">
.grecaptcha-badge {
	display: none;
}
</style>
<style lang="scss" scoped>
main {
	background-color: #f9fafd;
	.wrapper-form {
		padding: 40px;
		position: relative;
		width: 100%;
		height: 100%;
		min-height: 100vh;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		@media(max-width: 768px) {
			padding: 34px;
		}
		@media(max-width: 620px) {
			padding: 20px;
		}
		@media(max-width: 500px) {
			padding: 12px;
		}
		.banner-help-block {
			width: 100%;
			height: 100%;
			max-width: 1150px;
			display: flex;
			margin-top: 40px;
			background: #F9FAFD 0% 0% no-repeat padding-box;
			box-shadow: 0px 0px 45px #25529D4D;
			border-radius: 39px;
			overflow: hidden;
			@media(max-width: 620px) {
				flex-direction: column;
			}
			.col-6 {
				flex: 0 0 50%;
				max-width: 50%;
				@media (max-width: 960px) {
					flex: 0 0 100%;
					max-width: 100%;
				}
				&-content {
					display: flex;
					flex-direction: column;
					justify-content: center;
					padding: 30px;
					position: relative;
					z-index: 1;
					background-color: #FFFFFF;
					@media (max-width: 960px) {
						border-radius: 0 0 9px 9px;
						align-items: center;
					}
					&::after {
						content: '';
						position: absolute;
						top: 0;
						left: -20px;
						height: 100%;
						width: 100px;
						background-color: #ffffff;
						transform: skewX(-5deg);
						z-index: -1;
						@media (max-width: 960px) {
							top: -21px;
							left: 0;
							height: 100px;
							width: 100%;
							transform: skewY(-3deg);
						}
					}
					h3 {
						text-align: left;
						font: normal italic 900 24px/29px Montserrat;
						color: #4E4E4E;
						@media (max-width: 960px) {
							text-align: center;
						}
					}
					p {
						text-align: left;
						font: normal normal 400 16px/19px Montserrat;
						color: #4e4e4e;
						margin-top: 10px;
						@media (max-width: 960px) {
							text-align: center;
						}
					}
					.align-cta {
						display: flex;
						gap: 10px;
						flex-wrap: wrap;
						@media (max-width: 520px) {
							flex-direction: column;
							align-items: center;
						}
						.whatsapp-button {
							background-color: #25d366;
							&:deep(.button-inner) {
								.btn-text p {
									color: #ffffff;
								}
							}
						}
						a:after {
							display: none;
						}
					}
				}
				&-img {
					position: relative;
					display: flex;
					background-color: #2352A2;
					border-radius: 9px;
					@media (max-width: 960px) {
						border-radius: 9px 9px 0 0;
					}
					img {
						position: absolute;
						height: 100%;
						width: 100%;
						max-height: 250px;
						object-fit: contain;

						&.image-banner-contact {
							@media (max-width: 960px) {
								position: relative;
							}
						}
					}
				}
			}
		}
		.section-step {
			padding: 30px 0 0 50px;
			@media(max-width: 670px) {
				padding: 30px 0 0 30px;
			}
			@media(max-width: 630px) {
				padding: 30px 0 0 0;
			}
		}
		.heading-form {
			padding-bottom: 15px;
			border-bottom: 1px solid var(--color-alpha-3);
			margin-bottom: 20px;
			h3 {
				text-align: left;
				font: normal normal 900 20px/25px Montserrat;
				color: #4E4E4E;
			}
			p {
				text-align: left;
				font: normal normal 400 12px/15px Montserrat;
				color: #4e4e4e;
				margin-top: 5px;
			}

			@media(max-width: 630px) {
				display: none;
			}
		}
		.links-list {
			p {
				font-size: 14px;
			}
		}
		.banner-help-block .col-6-img {
			@media(max-width: 960px) {
				display: none;
			}
		}
		:deep(.card-form){
			max-width: 1150px;
			@media (max-width: 890px) {
				flex-direction: column;
			}
			.col-3 {
				.container-image-pattern {
					@media (max-width: 890px) {
						min-height: 80px;
					}
					@media (max-width: 500px) {
						min-height: 60px;
					}
					@media (max-width: 400px) {
						min-height: 40px;
					}
				}
			}
			.email-send {
				height: 0;
				padding: 0;
				overflow: hidden;
				transform: translate(-100%, 5%);
				@media (max-width: 890px) {
					transform: translate(0, -100%);
				}
				.container-content {
					height: 0;
				}
			}
			.pattern {
				@media (max-width: 890px) {
					flex: 0 0 100%;
					max-width: 100%;
					transform: translate(0);
				}
			}
			&.ctaDone {
				max-height: 800px;
				transition: height .4s $transition;
				.pattern {
					@media(max-width: 890px) {
						transform: translate(0, 465%)
					}
					@media(max-width: 500px) {
						transform: translate(0, 650%);
					}
					@media(max-width: 400px) {
						transform: translate(0, 1030%);
					}
				}
				.column-form {
					@media(max-width: 890px) {
						transform: translate(0, 100%);
					}
				}
				.email-send {
					height: auto;
					padding: 0 50px;
					transform: translate(0, 5%);
					@media (max-width: 890px) {
						transform: translate(0, 60%);
						flex: 0 0 100%;
						max-width: 100%;
					}
					@media (max-width: 620px) {
						padding: 0 30px;
					}
					@media (max-width: 350px) {
						transform: translate(0, 65%);
					}
					@media (max-width: 350px) {
						padding: 0 20px;
					}
					.container-content {
						height: 350px;
						h2 {
							@media (max-width: 660px) {
								font-size: 22px;
								line-height: 30px;
							}
							@media (max-width: 520px) {
								font-size: 20px;
								line-height: 28px;
							}
							@media (max-width: 400px) {
								font-size: 18px;
								line-height: 26px;
							}
							@media (max-width: 320px) {
								font-size: 16px;
								line-height: 24px;
							}
						}
						@media (max-width: 620px) {
							transform: translateY(0);
						}
					}
				}
			}
			.column-form {
				@media (max-width: 890px) {
					flex: 0 0 100%;
					max-width: 100%;
					transform: translate(0);
				}
				@media(max-width: 680px) {
					padding: 30px;
				}
				@media(max-width: 500px) {
					padding: 20px;
				}
			}
			.container-headings {
				@media(max-width: 350px) {
					padding-bottom: 10px;
				}
			}
			.container-image-pattern {
				&:after {
					@media (max-width: 950px) {
						left: 9%;
					}
					@media (max-width: 890px) {
						top: -790%;
						left: -21%;
						height: 1000%;
					}
				}
			}
			.container-inputs {
				height: 100%;
				@media(max-width: 630px) {
					display: flex;
					border-bottom: 1px solid #9eb6da;
					border-right: none;
					padding-top: 20px;
					justify-content: space-around;
				}
				@media(max-width: 350px) {
					padding-top: 15px;
				}
			}
			.row-step {
				@media(max-width: 630px) {
					flex-direction: column;
					padding-bottom: 0;
					margin-right: 20px;
					margin-bottom: 0;
					margin-left: 0;
					justify-content: center;
					align-items: center;
				}
				&:last-child {
					@media(max-width: 630px) {
						margin-right: 0;
					}
				}
				.content {
					@media(max-width: 630px) {
						width: 100%;
						text-align: center;
					}
					h4 {
						@media(max-width: 350px) {
							font-size: 12px;
							line-height: 14px;
						}
					}
					p {
						@media(max-width: 630px) {
							display: none;
						}
						@media(max-width: 350px) {
							margin-top: 2px;
							font-size: 8px;
							line-height: 12px;
						}
					}
				}
				.input-icon {
					@media(max-width: 630px) {
						margin-left: 0;
						margin-top: 10px;
					}
				}
				.step-indicator {
					@media(max-width: 630px) {
						margin-top: 10px;
						margin-left: 0;
						margin-right: 0px;
						margin-bottom: -8px;
					}
				}
			}
			.container-form {
				padding: 0;
				margin-left: 0;
				border-left: none;
				display: flex;
				@media(max-width: 630px) {
					flex-direction: column;
				}
				.container-step {
					display: flex;
				}
			}
			.input-wrapper {
				@media (max-width: 450px) {
					width: 300px;
				}
				@media (max-width: 400px) {
					width: 100%;
				}
			}
		}
	}

	.phone-label {
		color: var(--txt-1);
		font-size: 10px;
		line-height: 15px;
	}

	.phone-container {
		display: flex;
		align-items: stretch;
		justify-content: flex-start;
		width: 280px;
		transition: width .4s $transition;

		@media(max-width: 450px) {
			width: 300px;
		}

		@media(max-width: 400px) {
			width: 100%;
		}

		.input-phone-prefix {
			background-color: #fff;
			border-radius: 13px;
			box-shadow: 0 1px 2px var(--color-alpha-4);
			margin-right: 8px;
		}

	}

	.business-type-label {
		color: var(--txt-1);
		font-size: 10px;
		line-height: 15px;
		margin-bottom: 5px;
	}
	.business-type-row {
		user-select: none;
		justify-content: space-around;
		gap: 16px;
	}
}
</style>
